<template>
  <div :id="ID" class="load-hidden">
    <slot></slot>
  </div>
</template>

<script>
import ScrollReveal from 'scrollreveal'

export default {
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
    ID: {
      type: String,
      default: () => `reveal-${Math.random().toString(36).substr(2, 9)}`
    },
  },
  data() {
    return {
      baseOptions: {
        // 动画的时长
        duration: 2200,
        // 延迟时间
        delay: 5,
        // 动画开始的位置，'bottom', 'left', 'top', 'right'
        origin: 'bottom',
        // 回滚的时候是否再次触发动画
        reset: false,
        // 延时执行方式（always（一直延时执行），once（只延时执行一次），onload（只在加载时延时执行））
        // // useDelay: 'onload',
        // 在移动端是否使用动画
        mobile: true,
        // 滚动的距离，单位可以用%，rem等
        distance: '50px',
        // 其他可用的动画效果
        opacity: 0.01,
        // 执行速度 线性函数啥的
        easing: 'cubic-bezier(0.5, 0, 0, 1)',
        // 执行方式（缩放）
        scale: 1,
        // 动画完成后清除监听，不设置就会出现页面其他元素出现重复动画问题
        cleanup: true
      },
      sr: null
    }
  },
  mounted() {
    this.retScroll();
  },
  methods: {
    retScroll() {
      if (!this.sr) {
        this.sr = ScrollReveal()
      }
      this.sr.reveal(`#${this.ID}`, {...this.baseOptions, ...this.options})
    },
    destroyScrollReveal() {
      if (this.sr) {
        this.sr.clean(`#${this.ID}`)
        this.sr.destroy()
        this.sr = null
      }
    }
  },
  beforeDestroy() {
    this.destroyScrollReveal()
  },
}

</script>

<style scoped>
.load-hidden {
  visibility: hidden;
}
</style>
